import { GenericRepository } from "../generic-repository/GenericRepository";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PurchasePayments } from "src/app/models/PurchasePayments/purchase-payments.model";
import { IPurchasePaymentRepository } from "./IPurchasePaymentRepository";
import { ResponseModel } from "../../models/SharedModels/response.model";

@Injectable(
    {
        providedIn: 'root'
    }
)

export class PurchasePaymentRepository extends GenericRepository<PurchasePayments> implements IPurchasePaymentRepository {


    url: string = environment.urlAddress;
    constructor(protected _http: HttpClient) {
        super(_http, 'api/PurchasePayments', environment.urlAddress);
    }
    GetAll(currentPage: number, recordsPerPage: number, filterText: string): Observable<any> {
        filterText = filterText.split('/').join('~');
        if (filterText == "") {
            filterText = "|";
        }
        return this._http
            .get(this.url + 'api/PurchasePayments/SelectAll' + '/' + currentPage + '/' + recordsPerPage + '/' + filterText, this.httpOptions).pipe(map(this.extractData), catchError(this.handleError));
    }

    GetNavRec(navType: number, currentIndex: number): Observable<any> {
        return this._http.get(this.url + 'api/PurchasePayments/NavRec' + '/' + navType + '/' + currentIndex, this.httpOptions).pipe(map(this.extractData), catchError(this.handleError));
    }
    SelectPostingSetup(postingSetup: any, paymentType: number, vendorCode: string, godownCode?: string): Observable<ResponseModel> {
        return this.PostData('/SelectPostingSetup' + '/' + paymentType + '/' + vendorCode + '/' + godownCode, postingSetup).pipe(map(this.extractData), catchError(this.handleError));
    }
    SelectVendorPayments(currentPage: number, recordsPerPage: number, vendorCode: string): Observable<any> {
        return this.GetById('SelectVendorPayments' + '/' + currentPage + '/' + recordsPerPage + '/' + vendorCode).pipe(map(this.extractData), catchError(this.handleError));
    }
}